import { Injectable } from "@angular/core";
import { AmazonService } from "../../../services/amazon.service";
import { Seller } from "../../../objects/amazon/seller";
import { error } from "util";

@Injectable()
export class AmazonCurrentSellerResolver {
    constructor(private amazonService: AmazonService) {
    }

    public resolve(): Promise<Seller> {
         return this.amazonService.getCurrentSeller().then(resp => {
            return resp;
        }).catch(err => {
             return null;
         });
    }

}



// WEBPACK FOOTER //
// ./app/components/amazon/amazon-info/amazon-currentSelleer.resolver.ts